/* MiataSpeed product gallery navigation (repo-owned: stores/miataspeed/theme/assets/ms-gallery.js)
 *
 * Adds to the stock theme's product page:
 *   - prev/next arrows overlaid on the main photo (desktop + mobile)
 *   - the thumbnail strip's own arrows now step the selected image (stock theme only scrolled the list)
 *   - prev/next arrows, a counter, keyboard arrows, tap-to-advance and swipe inside the lightbox
 *   - left/right keyboard arrows on the page itself (ignored while a form field has focus)
 *
 * It builds on the theme's own pieces rather than replacing them: the thumbnail anchors are the
 * image list, the existing thumbnail click handler swaps the main photo, and the existing
 * ProductModal is the lightbox. The "current image" is always read back from the active thumbnail,
 * so variant switches, thumbnail clicks and the theme's own swipe handler all stay in sync.
 *
 * Loaded with `defer` from templates/product.liquid so it runs after shop.js has registered its
 * ready/load handlers; the slick strip is initialised on window load, so we wait for that too.
 */
(function ($) {
  'use strict';
  if (!$) return;

  var ARROW = {
    left: '<svg class="icon icon-arrow-left" aria-hidden="true"><use xlink:href="#icon-arrow-left"></use></svg>',
    right: '<svg class="icon icon-arrow-right" aria-hidden="true"><use xlink:href="#icon-arrow-right"></use></svg>'
  };
  var SWIPE_GUARD_MS = 400;

  function thumbs() {
    return $('#ProductThumbs .product-single__thumbnail');
  }

  function currentIndex() {
    var $all = thumbs();
    var i = $all.index($all.filter(function () { return $(this).parent().hasClass('is-active'); }));
    if (i < 0) {
      // Fall back to matching the main photo's src (same rule the theme uses in setActiveThumbnail)
      var src = $('#ProductPhotoImg').attr('src');
      i = $all.index($all.filter('[href="' + src + '"]'));
    }
    return i < 0 ? 0 : i;
  }

  function goTo(i, opts) {
    opts = opts || {};
    var $all = thumbs();
    var n = $all.length;
    if (!n) return;
    i = ((i % n) + n) % n;
    var $target = $all.eq(i);

    // Reuse the theme's handler: swaps #ProductPhotoImg + the modal trigger href, sets is-active.
    $target.trigger('click');

    // Keep the thumbnail strip scrolled to the new image.
    var $strip = $('#ProductThumbs');
    if ($strip.hasClass('slick-initialized')) {
      var slideIndex = parseInt($target.closest('.slick-slide').attr('data-slick-index'), 10);
      // dontAnimate=true (as the theme's own swipe code does): an animated slickGoTo is ignored
      // while the previous animation is still running, which let quick presses desync the strip.
      if (!isNaN(slideIndex)) $strip.slick('slickGoTo', slideIndex, true);
    }
    if (window.shop && shop.productThumbs) shop.productThumbs.index = i;

    if (opts.inModal) {
      var $zoom = $('#ProductZoomImg');
      $zoom.attr('src', '').attr('src', $target.attr('data-zoom') || $target.attr('href'));
    }
    updateCounter(i, n);
  }

  function updateCounter(i, n) {
    $('.ms-lightbox__counter').text((i + 1) + ' / ' + n);
  }

  function modalIsOpen() {
    return !!(window.shop && shop.ProductModal && shop.ProductModal.modalIsOpen);
  }

  function inFormField(el) {
    return /^(INPUT|SELECT|TEXTAREA)$/.test(el.nodeName) || el.isContentEditable;
  }

  function init() {
    var n = thumbs().length;
    if (n < 2) return; // single image: nothing to navigate

    // --- Main photo arrows -------------------------------------------------------------
    var $photo = $('#ProductPhoto').addClass('ms-gallery');
    var $prev = $('<button type="button" class="ms-gallery__arrow ms-gallery__arrow--prev" aria-label="Previous image">' + ARROW.left + '</button>');
    var $next = $('<button type="button" class="ms-gallery__arrow ms-gallery__arrow--next" aria-label="Next image">' + ARROW.right + '</button>');
    $photo.append($prev, $next);
    $prev.on('click', function (e) { e.preventDefault(); goTo(currentIndex() - 1); });
    $next.on('click', function (e) { e.preventDefault(); goTo(currentIndex() + 1); });

    // --- Thumbnail strip arrows --------------------------------------------------------
    // Stock slick arrows page the list three thumbnails at a time without changing the photo.
    // Take them over: each press selects the previous/next image (goTo scrolls the strip to it).
    var $strip = $('#ProductThumbs');
    $strip.find('.slick-prev').off('click.slick').on('click', function (e) { e.preventDefault(); goTo(currentIndex() - 1); });
    $strip.find('.slick-next').off('click.slick').on('click', function (e) { e.preventDefault(); goTo(currentIndex() + 1); });

    // --- Lightbox ----------------------------------------------------------------------
    var $modal = $('#ProductModal');
    if ($modal.length) {
      $modal.addClass('ms-lightbox');
      var $lPrev = $('<button type="button" class="ms-lightbox__arrow ms-lightbox__arrow--prev" aria-label="Previous image">' + ARROW.left + '</button>');
      var $lNext = $('<button type="button" class="ms-lightbox__arrow ms-lightbox__arrow--next" aria-label="Next image">' + ARROW.right + '</button>');
      var $counter = $('<div class="ms-lightbox__counter" aria-live="polite"></div>');
      $modal.append($lPrev, $lNext, $counter);

      // The theme closes the modal on any click whose target is not the IMG; stop our
      // controls from bubbling into that handler.
      $lPrev.on('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo(currentIndex() - 1, { inModal: true }); });
      $lNext.on('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo(currentIndex() + 1, { inModal: true }); });
      $counter.on('click', function (e) { e.stopPropagation(); });

      // Tap / click the big image to advance. A swipe (touch or mouse drag) also fires a
      // click on release in some browsers, so a swipe suppresses the click briefly after.
      var lastSwipe = 0;
      $modal.on('click', '#ProductZoomImg', function () {
        if (Date.now() - lastSwipe < SWIPE_GUARD_MS) return;
        goTo(currentIndex() + 1, { inModal: true });
      });
      // shop.js bundles a touch-events shim that emits jQuery 'swipeleft'/'swiperight'.
      $modal.on('swipeleft swiperight', function (e) {
        lastSwipe = Date.now();
        goTo(currentIndex() + (e.type === 'swipeleft' ? 1 : -1), { inModal: true });
      });

      $('#ProductPhotoLink').on('click', function () { updateCounter(currentIndex(), thumbs().length); });
    }

    // --- Keyboard ----------------------------------------------------------------------
    $(document).on('keydown.msGallery', function (e) {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      var dir = e.key === 'ArrowLeft' || e.keyCode === 37 ? -1 : e.key === 'ArrowRight' || e.keyCode === 39 ? 1 : 0;
      if (!dir) return;
      var open = modalIsOpen();
      if (!open && inFormField(e.target)) return;
      e.preventDefault();
      goTo(currentIndex() + dir, { inModal: open });
    });
  }

  // shop.js initialises the thumbnail slider on window load; run after it.
  $(function () {
    if (document.readyState === 'complete') init();
    else $(window).on('load.msGallery', init);
  });
})(window.jQuery);
